app.service('flatWarrantyManager', function(warrantyModal, broker) {
	let $self;
	let $warrantyPaymentTypeSelector;
	let $warrantyItems;
	let outletCategoryId;

	function handleWarrantyInfoClick() {
		const warrantyId = $(this).data('warranty-id');
		const warrantyPaymentType = $(this).data('warranty-type');

		warrantyModal.show(warrantyId, warrantyPaymentType, outletCategoryId);
	}

	function updateWarrantyPaymentTypeSelector(warrantyId, warrantyPaymentType) {
		$warrantyItems
			.filter(`[data-warranty-id=${warrantyId}]`)
			.find('.select3-input')
			.val(`${warrantyPaymentType}|${warrantyId}`)
			.change();
	}

	function showSelectedWarrantyPaymentType($selectedWarranty) {
		$selectedWarranty.addClass('is-visible').removeClass('is-hidden');

		$selectedWarranty
			.siblings()
			.addClass('is-hidden')
			.removeClass('is-visible');
	}

	function getSelectedWarranty(warrantyPaymentType, warrantyId) {
		return $warrantyItems
			.filter(`[data-warranty-payment-type=${warrantyPaymentType}]`)
			.filter(`[data-warranty-id=${warrantyId}]`);
	}

	function changeWarrantyPaymentType(warrantyPaymentType, warrantyId) {
		const $selectedWarranty = getSelectedWarranty(
			warrantyPaymentType,
			warrantyId
		);

		showSelectedWarrantyPaymentType($selectedWarranty);

		updateWarrantyPaymentTypeSelector(warrantyId, warrantyPaymentType);
	}

	function handleWarrantyPaymentTypeChange() {
		const selectedData = $(this)
			.val()
			.split('|');
		const warrantyPaymentType = selectedData[0];
		const warrantyId = selectedData[1];

		changeWarrantyPaymentType(warrantyPaymentType, warrantyId);
	}

	function setEvents() {
		$self.on('click', '.js-warranty-info', handleWarrantyInfoClick);

		broker.on(
			'WARRANTY_PAYMENT_TYPE_CHANGE',
			(e, warrantyPaymentType, warrantyId) =>
				changeWarrantyPaymentType(warrantyPaymentType, warrantyId)
		);

		$warrantyPaymentTypeSelector.on(
			'selectOption',
			handleWarrantyPaymentTypeChange
		);
	}

	function setElements() {
		$self = $('#warranties .warranties-container');

		$warrantyPaymentTypeSelector = $self.find(
			'.js-select-flat-warranty-type input'
		);

		$warrantyItems = $self.find('.item');
	}

	function setData(data) {
		outletCategoryId = data.outletCategoryId;
	}

	function init(data) {
		setData(data);
		setElements();
		setEvents();
	}

	return {
		init: init
	};
});
